import React, { useState, useEffect, useMemo } from "react";

import { Link } from "react-router-dom";
import { Row, Col, Spin } from "antd";

import { Main, CardToolbox } from "../styled";
import { PageHeader } from "../../components/page-headers/page-headers";
import { Button } from "../../components/buttons/buttons";

import { AutoComplete } from "../../components/autoComplete/autoComplete";

import { useTranslation } from "react-i18next";

import { GetBranchOffices } from "./dataQueries";
import {
  setAllBranchOfficces,
  setTableFiler,
} from "../../redux/branchOfficces/actionCreator";

import List from "./overview/list";
import { useDispatch, useSelector } from "react-redux";
import NewRecordModal from "./newRecordModal";
import { filtrujZoznam } from "../../utils/hladanie";
import { PanelFiltrov, moznostiZoZoznamu } from "../../components/filtre/panelFiltrov";

const graphqlVariables = {
  tokenGet: process.env.REACT_APP_TOKEN_GET,
  tokenMutation: process.env.REACT_APP_TOKEN_MUTATION,
};

const BranchOfficesGrid = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  const [gridState, setGridState] = useState({
    addNewRecord: false,
  });
  const showNewRecordModal = () => {
    setGridState({
      ...gridState,
      addNewRecord: true,
    });
  };
  const onCancel = () => {
    setGridState({
      ...gridState,
      addNewRecord: false,
    });
  };

  const handleCancel = () => {
    onCancel();
  };

  const tableData = useSelector(
    (state) => state?.branchOffices?.allBranchOffices
  );

  const [loadData, setLoadData] = useState(false);
  const [loadingList, setLoadingList] = useState(true);
  const [hladanie, setHladanie] = useState("");
  const PRAZDNE_FILTRE = { city: undefined, maZariadenie: undefined };
  const [filtre, setFiltre] = useState(PRAZDNE_FILTRE);

  useEffect(() => {
    setLoadData(true);
  }, []);

  // Pomocnik vracia undefined, kym nie su data. Bez tejto poistky padne
  // cela stranka na "Cannot read properties of undefined (reading '0')".
  const graphQlData = GetBranchOffices(graphqlVariables, loadData) || [];
  const pobocky = graphQlData[0]?.data?.getBranchOficces;
  const nacitavaSa = graphQlData[0]?.loading;

  // Zapis do uloziska patri do efektu, nie do vykreslovania. Predtym sa
  // dispatch volal priamo pocas renderu, co React hlasi ako chybu a pri
  // kazdom prekresleni to spustalo dalsie prekreslenie.
  useEffect(() => {
    if (!pobocky) return;
    dispatch(setAllBranchOfficces(pobocky));
    setLoadingList(Boolean(nacitavaSa));
    setLoadData(false);
  }, [pobocky, nacitavaSa, dispatch]);

  // Pobocka sa da najst aj podla mesta, adresy, telefonu alebo IC.
  const handleSearch = (searchText) => {
    setHladanie(typeof searchText === "string" ? searchText : "");
  };

  const definicieFiltrov = useMemo(
    () => [
      {
        kluc: "city",
        popis: "Mesto",
        typ: "vyber",
        sirka: 8,
        moznosti: moznostiZoZoznamu(tableData, (p) => p?.city),
      },
      {
        // Pobocka bez zariadenia nema kalendar, cize sa na nu neda objednat.
        // Takych je 8 zo 43.
        kluc: "maZariadenie",
        popis: "Má kalendár",
        typ: "vyber",
        sirka: 6,
        moznosti: [
          { hodnota: "ano", popis: "áno" },
          { hodnota: "nie", popis: "nie" },
        ],
      },
    ],
    [tableData]
  );

  const zobrazene = useMemo(() => {
    let data = filtrujZoznam(tableData, hladanie, (item) => [
      item?.company,
      item?.firstname,
      item?.lastname,
      item?.city,
      item?.street,
      item?.zip,
      item?.phone,
      item?.email,
      item?.ic,
      item?.dic,
      item?.ic_dph,
      item?.note,
    ]);
    if (filtre.city) {
      data = data.filter((p) => String(p?.city ?? "").trim() === filtre.city);
    }
    if (filtre.maZariadenie) {
      const chcem = filtre.maZariadenie === "ano";
      data = data.filter((p) => ((p?.devices || []).length > 0) === chcem);
    }
    return data;
  }, [tableData, hladanie, filtre]);

  useEffect(() => {
    dispatch(setTableFiler(zobrazene));
  }, [zobrazene, dispatch]);

  return (
    <>
      <CardToolbox>
        <PageHeader
          ghost
          title="Pobočky"
          subTitle={
            <>
              <span className="title-counter">{t("carOwners.filter")} </span>
              <AutoComplete
                onSearch={handleSearch}
                // dataSource={notData}
                placeholder={t("carOwners.startWritting")}
                width="100%"
                patterns
              />
            </>
          }
          buttons={[
            <Button
              onClick={showNewRecordModal}
              className="btn-add_new"
              size="default"
              type="primary"
              key="1"
            >
              {/* <Link to="/admin/users/add-user/info">+ Add New Car</Link> */}
              <Link to="#">{t("common.addRecord")}</Link>
            </Button>,
          ]}
        />
      </CardToolbox>
      <Main>
        <Row gutter={15}>
          <Col md={24}>
            <PanelFiltrov
              filtre={definicieFiltrov}
              hodnoty={filtre}
              onZmena={(kluc, hodnota) =>
                setFiltre((predosle) => ({ ...predosle, [kluc]: hodnota }))
              }
              onVycistit={() => setFiltre(PRAZDNE_FILTRE)}
            />
          </Col>
        </Row>
        <Row gutter={15}>
          <Col md={24}>
            {loadingList && (
              <div className="spin">
                <Spin />
              </div>
            )}
            {!loadingList && (
              <List inputData={zobrazene} graphqlVariables={graphqlVariables} />
            )}
          </Col>
        </Row>
      </Main>
      <NewRecordModal
        t={t}
        gridState={gridState}
        handleCancel={handleCancel}
        onCancel={onCancel}
        tableData={tableData}
      />
    </>
  );
};

export default BranchOfficesGrid;
